import './diagnostics/browser'
import 'element-closest'
import {createRoot, HashRouter, ReduxProvider} from 'external/react'
import serializeError from 'serialize-error'
import {logout, switchToClassic} from './context/post'
import {subdomainResource, subdomainLink} from './helpers/url'
import loadingApp from './router' 
import './index.styl'
import store from 'uploads/redux/store'

function setScreenHeight() {
  document.querySelector(':root').style.setProperty('--screen-height', `${window.innerHeight}px`)
}

window.addEventListener('resize', setScreenHeight)
window.addEventListener('load', setScreenHeight)
setScreenHeight()
setTimeout(setScreenHeight, 3000)

window.onChatContainer = function(container, pageName) {
  const $chat = document.getElementById('chat')
  if (pageName == 'chat') {
    if (!$chat.src) $chat.src =subdomainLink('talk')
    $chat.style.display = 'block';
    $chat.style.position = 'absolute';
    $chat.style.top = container.offsetTop + 'px';
    $chat.style.left = container.offsetLeft + 'px';
    $chat.style.width = container.clientWidth + 'px';
    $chat.style.height = container.clientHeight + 'px';
  } else {
    $chat.style.display = 'none';
  }
}

function renderApp(App) {
  const root = createRoot(document.getElementById('root'))
  root.render((
    <HashRouter>
      <ReduxProvider store={store}><App /></ReduxProvider>
    </HashRouter>
  ))
}

async function goToClassic(error) {
  const environment = process.env.NODE_ENV || 'development'
  if (environment != 'development') {
    await switchToClassic(error ? serializeError(error) : undefined)
    location.replace(`//${subdomainResource('www')}`)
  } else {
    console.log(error)
  }
}

async function handleLoadingError() {
  const environment = process.env.NODE_ENV || 'development'
  if (environment != 'development') {
    try {
      return await logout()
    } finally {
      return location.replace(`//${subdomainResource('www')}`)
    }
  } else {
    console.log(arguments)
  }
}

loadingApp().then(renderApp).catch(handleLoadingError)
